// src/components/Course/StartCourse.jsx
import React, { useState, useEffect, useMemo } from "react";
import VideoPlayer from "./vedioPleyer";
import ModulesList from "./ModulesList";
import "./Course.css";
import { useQuery } from "@tanstack/react-query";
import { BASE_URL } from "../../Config/Config";
import { useParams } from "react-router-dom";

const COURSE_IMAGE = "/mnt/data/d4a50b9f-e64f-42a6-b232-666dab9e7a74.png";

function StartCourse() {
  const [activeVideo, setActiveVideo] = useState(null);
  const [completedVideos, setCompletedVideos] = useState([]);
  const [openModule, setOpenModule] = useState(null);
  const {slug} = useParams();
  /** ------------------------
   *  🔥 Fetch Course Videos
   * ------------------------ */
  const { data: videosData, isLoading } = useQuery({
    queryKey: ["courseVideos"],
    queryFn: async () => {
      const response = await fetch(`${BASE_URL}/course_video/?course_slug=${slug}`);
      const result = await response.json();
      return result.data;
    },
  });

  console.log("videosData",videosData)

  /** ------------------------
   *  🔥 Convert API Data → Module wise grouping
   * ------------------------ */
 const modules = useMemo(() => {
  if (!videosData) return [];
  const grouped = {};

  videosData.forEach((item) => {
    const m = item.course_module;

    if (!m || !m.id) {
       console.warn("⚠ Missing module in API item:", item);
      return;
    }

    if (!grouped[m.id]) {
      grouped[m.id] = {
        id: m.id,
        title: m.module_title || "Untitled Module",
        videos: [],
        quiz: item.quiz_available || false,
      };
    }
    console.log("item",item)
    grouped[m.id].videos.push({
      id: item.id,
      title: item.coursevideo_title || "Untitled Video",
      heading:item?.coursevideo_heading,
      url: item.course_video ? `${BASE_URL}${item.course_video}` : "",
      duration: item.duration || "—",
      pdf: item.pdf_file ? `${BASE_URL}${item.pdf_file}` : null,
      pdf_thumb: item.pdf_thumbnail ? `${BASE_URL}${item.pdf_thumbnail}` : null,
      thumbnail: item.video_thumbnail ? `${BASE_URL}${item.video_thumbnail}` : null,
      quizzes: item?.quizzes || [],    
      pdf_title : item?.pdf_title,
      description : item?.description,

    });
  });

  return Object.values(grouped).sort((a, b) => a.id - b.id);
}, [videosData]);

console.log("modules",modules)

  /** ------------------------
   *  Select First Video Automatically
   * ------------------------ */
  useEffect(() => {
    if (!activeVideo && modules.length > 0) {
      setActiveVideo(modules[0].videos[0]);
      setOpenModule(modules[0].id);
    }
  }, [modules]);

  /** ------------------------
   * Video Select Handler
   * ------------------------ */
  const handleVideoSelect = (video) => {
    setActiveVideo(video);
  };

  /** ------------------------
   * Mark Video Complete
   * ------------------------ */
  const handleVideoComplete = (videoId) => {
    setCompletedVideos((prev) =>
      prev.includes(videoId) ? prev : [...prev, videoId]
    );
  };

  /** ------------------------
   * Calculate Course Progress
   * ------------------------ */
  const totalVideos = modules.reduce((acc, m) => acc + m.videos.length, 0);
  const completedCount = completedVideos.length;
  const progressPct = totalVideos ? Math.round((completedCount / totalVideos) * 100) : 0;
const courseInfo = videosData?.[0]?.course_module?.course;

  return (
    <div className="container my-4">

      {/* ----------------- COURSE HEADER ------------------ */}


     <div className="card course-header p-3 mb-4">
  <div className="d-flex align-items-center">
    <img
      src={courseInfo?.CourseMaster_tumbimage ? `${BASE_URL}${courseInfo.CourseMaster_tumbimage}` : COURSE_IMAGE}
      alt={courseInfo?.CourseMaster_title || "course"}
      className="course-thumb me-3"
    />

    <div className="flex-grow-1">
      <h3 className="mb-1 course-title">
        {courseInfo?.CourseMaster_title || "Untitled Course"}
      </h3>
      <div className="small text-muted">
        {completedCount} / {totalVideos} Videos Completed
      </div>

      {/* <div className="progress mt-2" style={{ height: 8 }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${progressPct}%` }}
        />
      </div> */}
    </div>

    {/* <div className="ms-3 text-end">
      <button className="btn btn-outline-primary btn-sm mb-2">Subscribe Now</button>
      <br />
      <button className="btn btn-primary btn-sm">Resume</button>
    </div> */}
  </div>
</div>


      {/* ------------------ MAIN COURSE LAYOUT ------------------ */}
      <div className="row">
        {/* LEFT: VIDEO PLAYER */}
        <div className="col-lg-8">
          <div className="card player-card p-3">
            <VideoPlayer
              video={activeVideo}
              onComplete={handleVideoComplete}
            />
          </div>
        </div>

        {/* RIGHT: MODULE LIST */}
        <div className="col-lg-4">
          <div className="card modules-card p-3">
            <h5 className="mb-3">Learning</h5>
            <ModulesList
              modules={modules}
              openModule={openModule}
              setOpenModule={setOpenModule}
              activeVideo={activeVideo}
              onVideoSelect={handleVideoSelect}
              completedVideos={completedVideos}
            />

          </div>
        </div>
      </div>
    </div>
  );
}

export default StartCourse;
